var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "快捷短语设置",
        visible: _vm.visibleProxy,
        width: "640px",
        "append-to-body": "",
        "custom-class": "fre-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed
      }
    },
    [
      _c(
        "div",
        { staticClass: "fre-row" },
        [
          _c("div", { staticClass: "fre-label" }, [
            _vm._v("请输入快捷短语（700字以内）")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 6,
              maxlength: "700",
              "show-word-limit": "",
              placeholder: ""
            },
            model: {
              value: _vm.form.content,
              callback: function($$v) {
                _vm.$set(_vm.form, "content", $$v)
              },
              expression: "form.content"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fre-row fre-flex" },
        [
          _c("div", { staticClass: "fre-label" }, [_vm._v("选择分组")]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "fre-group-select",
              attrs: { placeholder: "请选择" },
              model: {
                value: _vm.form.group,
                callback: function($$v) {
                  _vm.$set(_vm.form, "group", $$v)
                },
                expression: "form.group"
              }
            },
            _vm._l(_vm.groups, function(g) {
              return _c("el-option", {
                key: g.id,
                attrs: { label: g.name, value: g.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.showAddGroup
            ? _c("el-input", {
                staticClass: "fre-group-input",
                attrs: { placeholder: "请输入分组名" },
                model: {
                  value: _vm.newGroup,
                  callback: function($$v) {
                    _vm.newGroup = $$v
                  },
                  expression: "newGroup"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showAddGroup
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addGroup }
                },
                [_vm._v("添加")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fre-row" },
        [
          _c("div", { staticClass: "fre-label" }, [_vm._v("快捷编码")]),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "fre-code-input",
            attrs: { placeholder: "字母、数字、中文" },
            model: {
              value: _vm.form.code,
              callback: function($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fre-tips" }, [
        _vm._v(
          "\n\t\t输入框输入“/”+“快捷编码”或关键字,可以进行搜索。输入数字、↑、↓ 键进行选择，回车键进行确认。\n\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.saving },
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.saving,
                disabled: _vm.saving
              },
              on: { click: _vm.onConfirm }
            },
            [_vm._v("确认")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c92a3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c92a3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/FastReplyEditorDialog.vue
// module id = 1711
// module chunks = 0